import _ from 'lodash'
import moment from 'moment'
import React from 'react'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import DatePicker from 'react-datepicker'
import { Field, reduxForm } from 'redux-form'

const DefectEdit = props => {
  const {
    handleSubmit, submitting, initialValues, onSubmit, goBack, comments,
    searchUser, setUserSelected, assignee, errors, expectedDeliveryDate, onExpectedDeliveryDateChanged,
    onCommentSubmit, commentErrors, commentImages, commentImageData, uploadCommentImage,
  } = props
  if (!initialValues) return (<div/>)
  let statuses
  switch (initialValues.status) {
    case 'OPEN':
      statuses = ['ACCEPT']
      break
    case 'ACCEPT':
      statuses = ['ACCEPT', 'INPROGRESS']
      break
    case 'INPROGRESS':
      statuses = ['INPROGRESS', 'DONE']
      break
    case 'DONE':
      statuses = ['DONE', 'CLOSE', 'REOPEN']
      break
    case 'REOPEN':
      statuses = ['REOPEN', 'ACCEPT']
      break
    default:
      statuses = [initialValues.status]
      break
  }
  const statusOptions = _.map(statuses, (status) => (
    <option key={status} value={status}>{status}</option>
  ))
  const image = initialValues.defectImages && initialValues.defectImages.length > 0 ? (
    <div className="row mg-t-20">
      <label className="col-sm-4 form-control-label">รูปภาพบริเวณที่เกิดข้อบกพร่อง:</label>
      <div className="col-sm-8">
        {_.map(initialValues.defectImages || [], defectImage => (
          <div key={defectImage.id} className="float-left mg-r-10">
            <a href={defectImage.imageUrl}>
              <img src={defectImage.imageUrl ? defectImage.imageUrl : 'http://via.placeholder.com/64?text=No%20Image'} alt="" style={{ height: '64px', width: '64px' }}/>
            </a>
          </div>
        ))}
      </div>
    </div>
  ) : undefined
  const comment = comments.length > 0 ? (
    <div className="row mg-y-20">
      <div className="col-sm-4">
        <label className="form-control-label">ความคิดเห็น :</label>
      </div>
      <div className="col-sm-8">
        <div className="bg-gray-300">
          <div className="timeline pd-t-15">
            {_.map(comments, comment => (
              <div className={`container-timeline ${comment.my ? 'right' : 'left'}`}>
                <div key={comment.id} className="card" style={{ marginBottom: '15px' }}>
                  <div className="card-body color-gray-lighter">
                    <div className="">
                      {comment.comment}
                    </div>
                    <br/>
                    <div className="">
                      {_.map(comment.commentImages || [], commentImage => (
                        <div key={commentImage.id} className="card mx-sm-1">
                          <img src={commentImage.imageUrl ? commentImage.imageUrl : 'http://via.placeholder.com/64?text=No%20Image'} alt="" style={{ height: '64px', width: '64px' }}/>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="card-footer">
                    <span className="">{moment(comment.updatedAt).fromNow()}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>  
      </div>
    </div>
  ) : undefined
  return (
    <div>
      <div className="pd-x-20 pd-sm-x-30 pd-t-20 pd-sm-t-30">
        <h4 className="tx-gray-800 mg-b-5">แก้ไขข้อบกพร่อง</h4>
      </div>
      <div className="br-pagebody">
        <div className="br-section-wrapper">
          <div className="row">
            <div className="col-lg-12">
              <form className="form-layout form-layout-5" onSubmit={handleSubmit((values) => {
                onSubmit(values, expectedDeliveryDate, assignee.selected[0])
              })}>
                <div className="align-items-center justify-content-center">
                  <div className="">
                    <div className="">
                      <div>
                        <div className="row">
                          <label htmlFor="detail" className="col-sm-4 form-control-label form-label-custom">รายละเอียด :</label>
                          <div className="col-sm-8">
                            <Field name="detail" component="textarea" type="text" placeholder="รายละเอียด" rows="5"
                                   className="form-control" disabled={true}/>
                          </div>
                        </div>
                        <div className="row mg-t-20">
                          <label htmlFor="status" className="col-sm-4 form-control-label">สถานะ :</label>
                          <div className="col-sm-8">
                            <Field name="status" component="select" className="form-control">
                              {statusOptions}
                            </Field>
                          </div>
                        </div>
                        <div className="row mg-t-20">
                          <label htmlFor="expectedDeliveryDate" className="col-sm-4 form-control-label">
                            วันที่คาดว่าจะเสร็จ :</label>
                          <div className="col-sm-8 datepicker-container">
                            <DatePicker className="form-control" placeholderText="คลิกเพื่อเลือกวันที่"
                                        dateFormat="DD/MM/YYYY"
                                        selected={expectedDeliveryDate}
                                        onChange={onExpectedDeliveryDateChanged}/>
                            {errors.expectedDeliveryDate ? <span
                              className="text-danger">{errors.expectedDeliveryDate}</span> : undefined}
                          </div>
                        </div>
                        <div className="row mg-t-20">
                          <label htmlFor="project" className="col-sm-4 form-control-label">โครงการ :</label>
                          <div className="col-sm-8">
                            <Field name="project.name" component="input" type="text" placeholder="โครงการ"
                                   className="form-control" disabled={true}/>
                          </div>
                        </div>
                        <div className="row mg-t-20">
                          <label htmlFor="mainArea" className="col-sm-4 form-control-label">พื้นที่หลัก :</label>
                          <div className="col-sm-8">
                            <Field name="mainArea.name" component="input" type="text" placeholder="พื้นที่หลัก"
                                   className="form-control" disabled={true}/>
                          </div>
                        </div>
                        <div className="row mg-t-20">
                          <label htmlFor="defectArea"
                                 className="col-sm-4 form-control-label">บริเวณที่เกิดข้อบกพร่อง :</label>
                          <div className="col-sm-8">
                            <Field name="defectArea.name" component="input" type="text" placeholder="บริเวณที่เกิดข้อบกพร่อง"
                                   className="form-control" disabled={true}/>
                          </div>
                        </div>
                        <div className="row mg-t-20">
                          <label htmlFor="assignee" className="col-sm-4 form-control-label">มอบหมายให้ :</label>
                          <div className="col-sm-8">
                            <AsyncTypeahead
                              defaultSelected={assignee.defaultSelected}
                              multiple={false} minLength={1} labelKey="name" placeholder="ค้นหาผู้ที่เกี่ยวข้อง..."
                              isLoading={assignee.isLoading || false} options={assignee.list ? assignee.list.rows : []}
                              onSearch={(query) => searchUser(query, 'assignee')}
                              onChange={(selected) => setUserSelected(selected, 'assignee')}/>
                            {errors.assignee ? <span className="text-danger">{errors.assignee}</span> : undefined}
                          </div>
                        </div>
                        {image}
                        {comment}
                        <CommentAdd onSubmit={onCommentSubmit} errors={commentErrors} images={commentImages}
                                      imageData={commentImageData} uploadImage={uploadCommentImage}/>
                      </div>
                      <div className="row mg-t-30">
                        <div className="col-sm-8 mg-l-auto">
                          <div className="form-layout-footer">
                            <button type="submit" className="btn btn-teal" disabled={submitting}>แก้ไขข้อบกพร่อง</button>
                            <span>&nbsp;&nbsp;&nbsp;</span>
                            <button type="button" className="btn btn-secondary" disabled={submitting} onClick={goBack}>กลับ</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>      
  )
}

let CommentAdd = props => {
  const { handleSubmit, onSubmit, pristine, reset, submitting, errors, images, imageData, uploadImage } = props
  return (
    <div className="row mg-t-20">
      <div className="col-sm-4"></div>
      <div className="col-sm-8">
        <div className="card">
          <div className="card-header d-flex align-items-center justify-content-between">
            <h5 className="tx-16">กรอกความคิดเห็น</h5>
          </div>
          <div className="card-body">
            <form className="form-layout form-layout-1 bd-0 pd-0" onSubmit={handleSubmit((values) => {
              onSubmit(values, images, reset)
            })}>
              <div className="">
                <div className="">
                  <div className="form-group">
                    <div className="">
                      <Field name="comment" component="textarea" type="text" placeholder="ความคิดเห็น" rows="3"
                             className="form-control"/>
                      {errors.comment ? <span className="text-danger">{errors.comment}</span> : undefined}
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="custom-file">
                      <input type="file" className="custom-file-input wd-md-450" accept="image/*" multiple onChange={uploadImage}/>
                      <span className="custom-file-control"></span>
                    </label>
                  </div>
                  <div className="row justify-content-left mg-l-0">
                    <button type="submit" className="btn btn-info" disabled={pristine || submitting}>สร้างความคิดเห็น</button>
                  </div>
                </div>
              </div>
              <div className="row">
                {_.map(imageData || [], (data, index) => (
                  <div key={index} className="float-left mg-r-10">
                    <img src={data} alt="" style={{ height: '64px', width: '64px' }}/>
                  </div>
                ))}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>  
  )
}

CommentAdd = reduxForm({
  form: 'comment-add'
})(CommentAdd)

export default reduxForm({
  form: 'defect-edit',
  enableReinitialize: true,
})(DefectEdit)


// WEBPACK FOOTER //
// ./src/components/DefectEdit.js